module.exports = __webpack_public_path__ + "img/or.912a446c.svg";